import MaskedField from '../../../../components/FormInputs/MaskedField';
import LangEnum from '../../../../lang/LangEnum';
import teceoInputConfig from '../../../../utils/TeceoInputConfig';
import { cellphoneRegex } from '../../../../utils/regexes';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { CustomerSupportSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const CustomerSupportSectionGeneralSettings = ({
  generalSettings,
  handleChange,
  handleBlur,
}: CustomerSupportSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_CUSTOMER_SUPPORT_TITLE)}
      description={LangEnum.GENERAL_SETTINGS_CUSTOMER_SUPPORT_DESCRIPTION}
    >
      <MaskedField
        {...teceoInputConfig}
        label={translate(LangEnum.GLOBAL_WHATSAPP)}
        name="customerSupportPhone"
        mask={cellphoneRegex}
        value={generalSettings.customerSupportPhone}
        slotProps={{ inputLabel: { shrink: !!generalSettings.customerSupportPhone } }}
        onBlur={() => handleBlur()}
        onChange={(event) =>
          handleChange({ value: event.target.value || null, name: 'customerSupportPhone' })
        }
      />
    </SettingContainer>
  );
};

export default CustomerSupportSectionGeneralSettings;
